import React from 'react';
import { Users, X } from 'lucide-react';

export function AddExecutorModal({ availableMembers, onAdd, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="add-executor-modal">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-gray-900">Add Executor</h3>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full"><X className="w-5 h-5 text-gray-500" /></button>
        </div>
        <p className="text-sm text-gray-600 mb-4">Select a family member to designate as an estate executor. They will be able to view and download documents marked as "Executors Only".</p>
        {availableMembers.length === 0 ? (
          <div className="text-center py-6 bg-gray-50 rounded-lg">
            <Users className="w-8 h-8 text-gray-400 mx-auto mb-2" />
            <p className="text-gray-600">All family members are already executors</p>
          </div>
        ) : (
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {availableMembers.map((member) => (
              <button key={member.user_id} onClick={() => onAdd(member.user_id)} className="w-full flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:border-teal-500 hover:bg-teal-50 transition-colors text-left" data-testid={`add-executor-${member.user_id}`}>
                <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                  <span className="text-gray-600 font-medium">{member.name?.charAt(0) || '?'}</span>
                </div>
                <div>
                  <p className="font-medium text-gray-900">{member.name}</p>
                  <p className="text-xs text-gray-500">{member.email}</p>
                </div>
              </button>
            ))}
          </div>
        )}
        <button onClick={onClose} className="w-full mt-4 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">Cancel</button>
      </div>
    </div>
  );
}
